import React from 'react';

const MonthlyPoMisToolbarHeading = () => (
  <span className="po-mis-monthly-toolbar-heading">
    <span className="po-mis-monthly-toolbar-heading__title">
      Monthly PO MIS
    </span>
    <span className="po-mis-monthly-toolbar-heading__right">
      <span className="po-mis-monthly-toolbar-heading__note">
        <strong>Note:</strong> The amounts in the table are in INR format
      </span>
      <span
        className="po-mis-monthly-toolbar-heading__separator"
        aria-hidden="true"
      />
    </span>
  </span>
);

export default MonthlyPoMisToolbarHeading;
